import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import Tooltip from '../Tooltip';

import { getPath } from 'utils';
import { APPLICATION_NEW_DRAW_REQUESTS_PATH } from 'constants/routes';

const TRUSTPOINT_URL = 'https://partner.trustpoint.ai/';
const MIGRATION_TOOLTIP =
  'This application is in the process of migration to TrustPoint. Please wait until the loan data is fully loaded.';

const propTypes = {
  application: PropTypes.shape({
    trustpoint: PropTypes.bool,
    trustpointOnboardingCompleted: PropTypes.bool,
  }).isRequired,
  token: PropTypes.string.isRequired,
  trustpointOnboardingCompleted: PropTypes.bool,
  size: PropTypes.string,
  block: PropTypes.bool,
  component: PropTypes.elementType,
};

const defaultProps = {
  trustpointOnboardingCompleted: undefined,
  size: undefined,
  block: false,
  component: Button,
};

function DrawRequestButton({ application, token, trustpointOnboardingCompleted, size, block, component: Component }) {
  const sm = size === 'sm';
  const onboardingCompleted = trustpointOnboardingCompleted !== undefined
    ? trustpointOnboardingCompleted
    : application.trustpointOnboardingCompleted;

  if (application.trustpoint && !onboardingCompleted) {
    return (
      <Tooltip data-title={MIGRATION_TOOLTIP} position="top">
        <span style={block ? { display: 'block', width: '100%' } : { display: 'inline-block' }}>
          <Component disabled bordered sm={sm}>
            Request Draw
          </Component>
        </span>
      </Tooltip>
    );
  }

  if (application.trustpoint && onboardingCompleted) {
    return (
      <Component href={TRUSTPOINT_URL} external rel="noopener noreferrer" sm={sm}>
        Request Draw
      </Component>
    );
  }

  return (
    <Component to={getPath(APPLICATION_NEW_DRAW_REQUESTS_PATH, { token })} sm={sm}>
      Request Draw
    </Component>
  );
}

DrawRequestButton.propTypes = propTypes;
DrawRequestButton.defaultProps = defaultProps;

export default DrawRequestButton;
